import React from 'react';
import LegalPage from './LegalPage';

const Terms: React.FC = () => <LegalPage documentId="terms" />;

export default Terms;
